module.exports = {"522629001":"仰阿莎街道","522629100":"柳川镇","522629101":"岑松镇","522629102":"南加镇","522629103":"南明镇","522629104":"革东镇","522629105":"太拥镇","522629106":"磻溪镇","522629107":"久仰镇","522629108":"南哨镇","522629109":"南寨镇","522629110":"观么镇","522629205":"敏洞乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522629.json
// module id = 2518
// module chunks = 0